import React from 'react';
import { getKeyboardLayout } from '../utils/gameUtils2';
import '../styles/Keyboard.css';

const Keyboard = ({ guessedLetters, onLetterClick, disabled }) => {
  const keyboardLayout = getKeyboardLayout();

  const getKeyClass = (letter) => {
    if (guessedLetters.includes(letter)) {
      return 'key-guessed';
    }
    return '';
  };

  return (
    <div className="keyboard">
      {keyboardLayout.map((row, rowIndex) => (
        <div key={rowIndex} className="keyboard-row">
          {row.map((letter) => (
            <button
              key={letter}
              className={`keyboard-key ${getKeyClass(letter)}`}
              onClick={() => onLetterClick(letter)}
              disabled={disabled || guessedLetters.includes(letter)}
            >
              {letter}
            </button>
          ))}
        </div>
      ))}
    </div>
  );
};

export default Keyboard; 